import { render, staticRenderFns } from "./FichaUsuarioDialog.vue?vue&type=template&id=775f3f23&"
import script from "./FichaUsuarioDialog.vue?vue&type=script&lang=js&"
export * from "./FichaUsuarioDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports